// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"33":"f9139896","129":"bdb18628","244":"7cf207dc","427":"b2289cdb","569":"3421f22e","653":"13bec97e","674":"69a65ec3","686":"d1b296c0","777":"11055b71","799":"cd9c03f7"}[chunkId] + ".js";
};